import { render, staticRenderFns } from "./MagenteModals.vue?vue&type=template&id=83056240"
import script from "./MagenteModals.vue?vue&type=script&lang=js"
export * from "./MagenteModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports